import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Lock = function Lock(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.90845 22.53H17.0916C18.4983 22.53 19.1912 21.8372 19.1912 20.3044V12.4414C19.1912 11.0557 18.6243 10.3523 17.4485 10.2368V7.6438C17.4485 3.65454 14.7925 1.7334 12 1.7334C9.20752 1.7334 6.55151 3.65454 6.55151 7.6438V10.2683C5.45972 10.4363 4.80884 11.1292 4.80884 12.4414V20.3044C4.80884 21.8372 5.50171 22.53 6.90845 22.53ZM8.56714 7.45483C8.56714 5.00879 10.1208 3.66504 12 3.66504C13.8687 3.66504 15.4329 5.00879 15.4329 7.45483V10.2158L8.56714 10.2263V7.45483Z"
  })));
};

Lock.displayName = 'Lock';
export default Lock;